module.exports = __webpack_public_path__ + "img/bg_等级徽章@2x.b1e3fcb9.png";